"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./Button.scss");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Button =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Button, _PureComponent);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
  }

  _createClass(Button, [{
    key: "render",

    /*eslint-disable */
    //suppress all warnings between comments
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          onClick = _this$props.onClick,
          children = _this$props.children,
          disabled = _this$props.disabled,
          secondary = _this$props.secondary,
          tertiary = _this$props.tertiary,
          quaternary = _this$props.quaternary,
          fluid = _this$props.fluid,
          rounded = _this$props.rounded,
          orange = _this$props.orange,
          orangeInverted = _this$props.orangeInverted,
          id = _this$props.id,
          type = _this$props.type,
          _this$props$testid = _this$props.testid,
          testid = _this$props$testid === void 0 ? '' : _this$props$testid;
      var className = 'c-Button';
      var data = Object.keys(this.props).filter(function (key) {
        return key.indexOf("data-") === 0;
      }).reduce(function (a, b) {
        a[b] = _this.props[b];
        return a;
      }, {});
      var activeClassNames = [className, disabled ? "".concat(className, "--disabled") : '', secondary ? "".concat(className, "--secondary") : '', tertiary ? "".concat(className, "--tertiary") : '', quaternary ? "".concat(className, "--quaternary") : '', fluid ? "".concat(className, "--fluid") : '', rounded ? "".concat(className, "--rounded") : '', orange ? "".concat(className, "--orange") : '', orangeInverted ? "".concat(className, "--orange-inverted") : ''].filter(Boolean).join(' ');
      return _react2.default.createElement("button", _extends({
        disabled: disabled,
        tabIndex: 0,
        onClick: onClick,
        type: type,
        className: activeClassNames,
        id: id,
        "data-testid": testid
      }, data), children);
    }
    /*eslint-enable */

  }]);

  return Button;
}(_react.PureComponent);

Button.defaultProps = {
  children: null,
  disabled: false,
  secondary: false,
  tertiary: false,
  quaternary: false,
  orange: false,
  rounded: false,
  onClick: _utils.noop,
  fluid: false,
  id: null,
  type: 'button',
  testid: ''
};
exports.default = Button;